import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../../utils";
import { BASE_URL } from "../../../request";
import SortDirection from "react-virtualized/dist/commonjs/Table/SortDirection";
import { FormattedMessage } from "react-intl";
import React from "react";
import { messages } from "../../../globalVariables";

const ModuleDefinition = {
  name: "Clients",
  entityName: "clients",
  filterFields: [
    "id",
    "idMyS",
    "name",
    "cif",
    "legalName",
    "description",
    "address",
    "cp",
    "city",
    "tax",
    "email",
    "fp",
    "iban",
  ],
  restConfig: {
    baseURL: `${BASE_URL}`,
    dataField: "content",
    create: {
      url: () => "api/clients",
      method: "post",
    },
    fetch: {
      url: ({ id }) => `api/clients${id ? "/" + id : "?size=10000"}`,
      method: "get",
    },
    update: {
      url: ({ id }) => `api/clients/${id}`,
      method: "put",
    },
    delete: {
      url: ({ id }) => `api/clients/${id}`,
      method: "delete",
    },
  },
  entities: [],
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "translations",
  },
  allowClone: false,
  allowDelete: false,
  allowExport: true,
  exportFileName: "crm_clients_export",
  sorting: {
    property: "name",
    sortable: true,
    sortDirection: SortDirection.ASC,
  },
  reorder: false,
  showTotalRecords: true,
  fields: {
    list: [
      {
        fieldName: "numContracts",
        displayName: "#Cont.",
        width: 60,
      },
      {
        fieldName: "id",
        displayName: "id",
        width: 60,
      },
      {
        fieldName: "idMyS",
        displayName: "id_MyS",
        width: 80,
      },
      {
        fieldName: "cif",
        displayName: "CIF",
        width: 120,
      },
      {
        fieldName: "name",
        displayName: "Alias",
        width: 160,
      },
      {
        fieldName: "description",
        displayName: "Nombre",
        width: 120,
      },
      {
        fieldName: "legalName",
        displayName: "Razon Social",
        width: 160,
      },
      {
        fieldName: "address",
        displayName: "Direccion",
        width: 200,
      },
      {
        fieldName: "cp",
        displayName: "CP",
        width: 60,
      },
      {
        fieldName: "city",
        displayName: "Ciudad",
        width: 120,
      },
      {
        fieldName: "tax",
        displayName: "IVA",
        width: 40,
      },
      {
        fieldName: "contact",
        displayName: "Contacto",
        width: 40,
      },
      {
        fieldName: "telephone",
        displayName: "Tel",
        width: 40,
      },
      {
        fieldName: "ccoRecipients",
        displayName: "CCO",
        width: 60,
      },
      {
        fieldName: "email",
        displayName: "Email",
        width: 160,
      },
      {
        fieldName: "comment",
        displayName: "Comment",
        width: 60,
      },
      {
        fieldName: "fp",
        displayName: "FP",
        width: 60,
      },
      {
        fieldName: "iban",
        displayName: "IBAN",
        width: 220,
      },
      {
        fieldName: "country",
        displayName: "Pais-Reg.",
        width: 80,
      },
      {
        fieldName: "taxInfo",
        displayName: "IVA COPY",
        width: 100,
      },
      {
        fieldName: "updated",
        displayName: "Updated",
        width: 120,
      },
      {
        fieldName: "lastUser",
        displayName: "Last user",
        width: 160,
      },
    ],
    form: [
      {
        fieldName: "id",
        displayName: "ID",
        widget: "input",
        readOnly: true,
        order: 10,
        visible: ({ formValues }) => formValues.id,
      },
      {
        fieldName: "idMyS",
        displayName: "ID MyS",
        widget: "input",
        order: 11,
      },
      {
        fieldName: "name",
        displayName: "ALIAS",
        className: "tickerInput",
        widget: "input",
        required: true,
        order: 20,
      },
      {
        fieldName: "cif",
        displayName: "CIF",
        widget: "input",
        required: true,
        order: 30,
      },
      {
        fieldName: "description",
        displayName: "Nombre",
        widget: "input",
        required: true,
        order: 40,
      },
      {
        fieldName: "legalName",
        displayName: "Razón Social",
        widget: "input",
        required: true,
        order: 50,
      },
      {
        fieldName: "address",
        displayName: "Dirección",
        widget: "input",
        order: 60,
      },
      {
        fieldName: "cp",
        displayName: "Código Postal",
        widget: "input",
        order: 70,
      },
      {
        fieldName: "city",
        displayName: "Ciudad",
        widget: "input",
        order: 80,
      },
      {
        fieldName: "country",
        displayName: "País",
        widget: "input",
        order: 90,
      },
      {
        fieldName: "tax",
        displayName: "IVA",
        widget: "input",
        required: true,
        order: 100,
      },
      {
        fieldName: "contact",
        displayName: "Contacto",
        widget: "input",
        order: 110,
      },
      {
        fieldName: "telephone",
        displayName: "Teléfono",
        widget: "input",
        required: true,
        order: 120,
      },
      {
        fieldName: "mobile",
        displayName: "Móvil",
        widget: "input",
        order: 130,
      },
      {
        fieldName: "email",
        displayName: "Email",
        widget: "input",
        order: 140,
      },
      {
        fieldName: "fp",
        displayName: "FP",
        widget: "selector",
        defaultValue: "DOM",
        optionDisplay: {
          DOM: {
            label: "DOM",
          },
          DOM30: {
            label: "DOM30",
          },
          TRB: {
            label: "TRB",
          },
          CRE: {
            label: "CRE",
          },
        },
        order: 160,
      },
      {
        fieldName: "iban",
        displayName: "IBAN",
        widget: "input",
        order: 170,
        visible: ({ formValues }) => formValues.fp === "DOM" || formValues.fp === "DOM30",
      },
      {
        fieldName: "ccoRecipients",
        displayName: "CCO",
        widget: "input",
        order: 200,
      },
      {
        fieldName: "taxInfo",
        displayName: "IVA_txt",
        widget: "input",
        order: 210,
      },
      {
        fieldName: "comment",
        displayName: "Comment",
        widget: "input",
        order: 220,
      },
    ],
  },
  validation: {
    name: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
        length: {
          maximum: 10,
          tooLong: "^No puede tener más de 10 caracteres",
        },
      },
    },
    iban: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: true,
        },
        format: {
          pattern: /^AL\d{10}[0-9A-Z]{16}$|^AD\d{10}[0-9A-Z]{12}$|^AT\d{18}$|^BH\d{2}[A-Z]{4}[0-9A-Z]{14}$|^BE\d{14}$|^BA\d{18}$|^BG\d{2}[A-Z]{4}\d{6}[0-9A-Z]{8}$|^HR\d{19}$|^CY\d{10}[0-9A-Z]{16}$|^CZ\d{22}$|^DK\d{16}$|^FO\d{16}$|^GL\d{16}$|^DO\d{2}[0-9A-Z]{4}\d{20}$|^EE\d{18}$|^FI\d{16}$|^FR\d{12}[0-9A-Z]{11}\d{2}$|^GE\d{2}[A-Z]{2}\d{16}$|^DE\d{20}$|^GI\d{2}[A-Z]{4}[0-9A-Z]{15}$|^GR\d{9}[0-9A-Z]{16}$|^HU\d{26}$|^IS\d{24}$|^IE\d{2}[A-Z]{4}\d{14}$|^IL\d{21}$|^IT\d{2}[A-Z]\d{10}[0-9A-Z]{12}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$|^KW\d{2}[A-Z]{4}22!$|^LV\d{2}[A-Z]{4}[0-9A-Z]{13}$|^LB\d{6}[0-9A-Z]{20}$|^LI\d{7}[0-9A-Z]{12}$|^LT\d{18}$|^LU\d{5}[0-9A-Z]{13}$|^MK\d{5}[0-9A-Z]{10}\d{2}$|^MT\d{2}[A-Z]{4}\d{5}[0-9A-Z]{18}$|^MR13\d{23}$|^MU\d{2}[A-Z]{4}\d{19}[A-Z]{3}$|^MC\d{12}[0-9A-Z]{11}\d{2}$|^ME\d{20}$|^NL\d{2}[A-Z]{4}\d{10}$|^NO\d{13}$|^PL\d{10}[0-9A-Z]{,16}n$|^PT\d{23}$|^RO\d{2}[A-Z]{4}[0-9A-Z]{16}$|^SM\d{2}[A-Z]\d{10}[0-9A-Z]{12}$|^SA\d{4}[0-9A-Z]{18}$|^RS\d{20}$|^SK\d{22}$|^SI\d{17}$|^ES\d{22}$|^SE\d{22}$|^CH\d{7}[0-9A-Z]{12}$|^TN59\d{20}$|^TR\d{7}[0-9A-Z]{17}$|^AE\d{21}$|^GB\d{2}[A-Z]{4}\d{14}$/,
          message: <FormattedMessage {...messages.ibanValidator} />,
        },
      },
    },

    cif: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    description: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    legalName: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    tax: {
      type: "Number",
      constraints: {
        numericality: {
          onlyInteger: true,
        },
        presence: {
          allowEmpty: false,
        },
      },
    },
    telephone: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    mobile: {
      constraints: {
        phone: {},
      },
    },
    email: {
      constraints: {
        emailList: {},
      },
    },
    ccoRecipients: {
      constraints: {
        emailList: {},
      },
    },
    idMyS: {
      type: "Number",
      constraints: {
        number: {},
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
